let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j5PkU")).then(() => parcelRequire('1NXaV'));